(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCustomHero() {
    const config = window.customHeroConfig;
    if (!config) return;

    const FRAME_COUNT = config.frameCount;
    const FRAME_DIGITS = config.frameDigits;
    const assetUrlPattern = config.assetUrlPattern;

    const container = document.getElementById('customHeroSequenceContainer');
    const canvas = document.getElementById('custom-hero-sequence-canvas');
    const ctx = canvas.getContext('2d');
    const loadingOverlay = document.getElementById('customHeroLoadingOverlay');
    const loadProgress = document.getElementById('customHeroLoadProgress');

    const overlayTitle = document.getElementById('customHeroOverlayTitle');
    const overlaySlogan1 = document.getElementById('customHeroOverlaySlogan1');
    const overlaySlogan2 = document.getElementById('customHeroOverlaySlogan2');
    const overlayCta = document.getElementById('customHeroOverlayCta');

    let images = [];
    let isLoaded = false;
    let currentFrame = 0;

    function getFrameUrl(index) {
      const paddedIndex = index.toString().padStart(FRAME_DIGITS, '0');
      return assetUrlPattern.replace('00000', paddedIndex);
    }

    function preloadImages() {
      let loadedCount = 0;

      for (let i = 0; i < FRAME_COUNT; i++) {
        const img = new Image();
        img.src = getFrameUrl(i);

        img.onload = () => {
          loadedCount++;
          const percent = Math.round((loadedCount / FRAME_COUNT) * 100);
          loadProgress.textContent = percent;

          if (loadedCount === FRAME_COUNT) {
            isLoaded = true;
            loadingOverlay.classList.add('hidden');
            renderFrame(0);
          }
        };

        img.onerror = () => {
          loadedCount++;
          console.warn('Failed to load frame ' + i);
        };

        images.push(img);
      }
    }

    function renderFrame(index) {
      const img = images[index];
      if (!img || !img.complete) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const hRatio = canvas.width / img.width;
      const vRatio = canvas.height / img.height;
      const ratio = Math.max(hRatio, vRatio);

      const centerX = (canvas.width - img.width * ratio) / 2;
      const centerY = (canvas.height - img.height * ratio) / 2;

      ctx.drawImage(
        img,
        0, 0, img.width, img.height,
        centerX, centerY, img.width * ratio, img.height * ratio
      );
    }

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      if (isLoaded) {
        renderFrame(currentFrame);
      }
    }

    function getScrollProgress() {
      const rect = container.getBoundingClientRect();
      const containerTop = rect.top;
      const containerHeight = rect.height - window.innerHeight;

      const progress = -containerTop / containerHeight;
      return Math.max(0, Math.min(1, progress));
    }

    function lerp(start, end, t) {
      return start + (end - start) * t;
    }

    function mapRange(value, inMin, inMax, outMin, outMax) {
      const t = (value - inMin) / (inMax - inMin);
      return lerp(outMin, outMax, Math.max(0, Math.min(1, t)));
    }

    function updateOverlays(progress) {
      const titleOpacity = progress <= 0.1 ? 1 : mapRange(progress, 0.1, 0.2, 1, 0);
      const titleY = mapRange(progress, 0, 0.2, 0, -50);
      overlayTitle.style.opacity = titleOpacity;
      overlayTitle.style.transform = 'translateY(' + titleY + 'px)';

      let slogan1Opacity = 0;
      if (progress >= 0.25 && progress <= 0.35) {
        slogan1Opacity = mapRange(progress, 0.25, 0.35, 0, 1);
      } else if (progress > 0.35 && progress <= 0.45) {
        slogan1Opacity = mapRange(progress, 0.35, 0.45, 1, 0);
      }
      const slogan1Y = mapRange(progress, 0.25, 0.45, 50, -50);
      overlaySlogan1.style.opacity = slogan1Opacity;
      overlaySlogan1.style.transform = 'translateY(' + slogan1Y + 'px)';

      let slogan2Opacity = 0;
      if (progress >= 0.55 && progress <= 0.65) {
        slogan2Opacity = mapRange(progress, 0.55, 0.65, 0, 1);
      } else if (progress > 0.65 && progress <= 0.75) {
        slogan2Opacity = mapRange(progress, 0.65, 0.75, 1, 0);
      }
      const slogan2Y = mapRange(progress, 0.55, 0.75, 50, -50);
      overlaySlogan2.style.opacity = slogan2Opacity;
      overlaySlogan2.style.transform = 'translateY(' + slogan2Y + 'px)';

      const ctaOpacity = mapRange(progress, 0.85, 0.95, 0, 1);
      const ctaY = mapRange(progress, 0.85, 1, 50, 0);
      overlayCta.style.opacity = ctaOpacity;
      overlayCta.style.transform = 'translateY(' + ctaY + 'px)';
    }

    function onScroll() {
      const progress = getScrollProgress();

      if (isLoaded) {
        const frameIndex = Math.round(progress * (FRAME_COUNT - 1));
        const safeIndex = Math.max(0, Math.min(FRAME_COUNT - 1, frameIndex));

        if (safeIndex !== currentFrame) {
          currentFrame = safeIndex;
          requestAnimationFrame(() => renderFrame(currentFrame));
        }
      }

      updateOverlays(progress);
    }

    function init() {
      resizeCanvas();
      preloadImages();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', resizeCanvas);

      onScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  initCustomHero();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
